import React, { FC } from "react";
import { FieldStatus } from "../../Helpers/FieldStatus";

export enum SubmitType {
  next = "next",
  submit = "submit",
}

type SubmitProps = {
  status?: FieldStatus;
  type?: SubmitType;
  label?: string;
};

const submitText = {
  next: "Neste",
  submit: "Bekreft timebestilling",
};

export const Submit: FC<SubmitProps> = ({
  type = SubmitType.next,
  status = FieldStatus.active,
  label = undefined,
  children,
}) => {
  return (
    <button
      className="btn btn-primary booking-narrow-item w-100 mt-2"
      type="submit"
      disabled={status == FieldStatus.disabled}
    >
      {children || label || submitText[type]}
    </button>
  );
};
